import {$, w} from './constants';
import './contact';

w.load(() => {
	console.log('--Loaded');
});

// Cookies Functions variable init
var today = new Date()
var expiry = new Date(today.getTime() + 30 * 24 * 3600 * 1000)

$(document).ready(function() {

	$('.menu_close_JS').click(function () {
		$('.menu_JS').fadeOut()
	})
	$('.menu_open_JS').click(function () {
		$('.menu_JS').fadeIn()
	})

	$('.home_slider_JS').slick({
		dots: false,
		fade: true,
		speed: 500,
		arrows: true,
		slide: '.home_slider_item_JS',
		autoplay: false,
		pauseOnHover: false,
	})
	$('.home_mobile_JS').slick({
		dots: false,
		fade: true,
		speed: 500,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 6000,
		pauseOnHover: false,
	})

	// Comunidad child pages Over
	$('.over_btn_JS').click(function () {
		$('.over_JS').fadeIn()
		$('.header_JS,.footer_JS').addClass('invert')
	})
	$('.over_close_JS').click(function () {
		$('.over_JS').fadeOut()
		$('.header_JS,.footer_JS').removeClass('invert')
	})

	// Scholarship Accordion
	$('.group_btn_JS').click(function () {
		$(this).closest('.group_JS').toggleClass('active')
	})

	// Cookies Functions
	function getCookie(name) {
		var value = "; " + document.cookie
		var parts = value.split("; " + name + "=")
		if (parts.length == 2) return parts.pop().split(";").shift() //jshint ignore:line
	}
	function setCookie(name,value) {
		document.cookie=name + "=" + escape(value) + "; path=/; expires=" + expiry.toGMTString()  //jshint ignore:line
	}

	//Cookies activation
	if (getCookie('modal_close') != 1) {
		setCookie('modal_close',0);
	}
	$('.modal_close_JS').click(function () {
		$('.modal_JS').fadeOut()
		setCookie('modal_close',1)
	})

	//Libro Rosetta paypal link
	$('.libro_item_JS, .libro_price_JS').on('change', function () {
		const $wrapper = $(this).closest('.libro__prices');

		const paypalUser =
			$wrapper.find('.libro_paypal_JS').length &&
			$wrapper.find('.libro_paypal_JS').val()
				? $wrapper.find('.libro_paypal_JS').val()
				: 'danielcbs';

		const $itemSelect = $wrapper.find('.libro_item_JS');
		const $priceSelect = $wrapper.find('.libro_price_JS');
		const $btn = $wrapper.find('.libro_btn_JS');

		const itemValue = $itemSelect.find('option:selected').data('item');
		let priceValue = $priceSelect.val();

		// Reset prices when edition changes
		if ($(this).hasClass('libro_item_JS')) {
			$priceSelect.find('option')
				.removeClass('active')
				.prop('hidden', true);

			$priceSelect.find('option:first')
				.prop('hidden', false);

			if (itemValue !== 'none') {
				$priceSelect.find('option[data-item="' + itemValue + '"]')
					.addClass('active')
					.prop('hidden', false);
			}

			$priceSelect.prop('selectedIndex', 0);
			priceValue = null;
		}

		// Build link only when both selects are valid
		if (itemValue !== 'none' && priceValue) {
			const editionText = $itemSelect.find('option:selected').text();
			const shippingText = $priceSelect.find('option:selected').text();

			const note = encodeURIComponent(
				`Edición: ${editionText} / Envío: ${shippingText}`
			);

			const paypalLink =
				`https://www.paypal.me/${paypalUser}/${priceValue}?note=${note}`;

			$btn.attr('href', paypalLink)
				.addClass('active')
				.removeClass('disabled');
		} else {
			$btn.removeAttr('href')
				.removeClass('active')
				.addClass('disabled');
		}
	});

})

$(window).resize(function () {

	if ($(window).width() < 768) { $('.menu_JS').fadeOut() }

})

